(ns nosco.controllers
  (:require
   [clojure.edn :as edn]
   [goog.object :as gobj]
   [nosco.state.core :refer [<-deref]]
   [reseda.react :as rr]
   [reseda.state :as rs]))

(defonce app-state (atom {}))
(defonce app-store (rs/new-store app-state))

(defonce ^:export feature-flags-html
  (or (some->
       (gobj/get js/window "feature_flags")
       (edn/read-string)
       (some->>
        (map keyword)
        (set)))
      #{}))

(defn has-flag? [flag]
  (contains? feature-flags-html flag))

(defn use-get-viewer []
  (rr/useStore app-store :user))

(defn get-viewer! []
  (:user @app-state))

(defn get-conf! []
  (:siteConfiguration @app-state))

(defn ai-available?
  "Whether the server can resolve a configured AI feature on this site."
  [feature]
  (boolean (get-in (get-conf!) [:aiAvailability feature])))

(defn show-connected-apps?
  "Connected Apps are visible to a user when either:
   - the :ai-sandbox flag is on (our own CLJS agent), or
   - an admin has switched the MCP server on for the site (:mcpEnabled site
     configuration)."
  []
  (or (has-flag? :ai-sandbox)
      (boolean (:mcpEnabled (get-conf!)))))

(defn viewer-channel-admin? [ideabox-id]
  (let [viewer (get-viewer!)]
    (or (:isAdmin viewer)
        (contains? (set (:administeredIdeaboxes viewer))
                   ideabox-id))))

(defn viewer-channel-admin-only? [ideabox-id]
  (let [viewer (get-viewer!)]
    (and (not (:isAdmin viewer))
         (contains? (set (:administeredIdeaboxes viewer))
                    ideabox-id))))

(defn viewer-global-admin? []
  (let [viewer (get-viewer!)]
    (:isAdmin viewer)))

(defn use-members-hidden? []
  (-> (<-deref app-state) :siteConfiguration :membersHidden))

(defn global-permission? [permission]
  (let [viewer (:user @app-state)
        perms (set (:globalPermissions viewer))]
    (contains? perms (str permission))))

(defn permission? [subject permission]
  {:pre [(:permissions subject)]}
  (let [perms (set (:permissions subject))]
    (contains? perms (str permission))))

(defn use-get-user-selectable-locales []
  (rr/useStore app-store [:siteConfiguration :addons :userSelectableLocales]))

(defn get-ai-actions []
  (-> (deref app-state) :aiActions))
